import { useState } from "react";
import { ChevronDown } from "lucide-react";
import FadeInSection from "../../ui/fade-in-section";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../ui/accordian/accordion";

function IndustryAccordion({ industries }) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {industries.map((row, index) => (
        <AccordionItem
          key={row.industry}
          value={row.industry}
          className={`border-0 ${
            index < industries.length - 1 ? "border-b border-[#E8EEF4]" : ""
          }`}
        >
          <AccordionTrigger className="use-case-industry-trigger group flex items-center justify-between gap-3 py-4 px-4 sm:px-6 w-full text-left hover:no-underline [&>svg]:hidden">
            <span className="font-bold text-navy text-sm sm:text-[15px] leading-snug flex-1 min-w-0 pr-2">
              {row.industry}
            </span>
            <ChevronDown
              className="w-4 h-4 sm:w-5 sm:h-5 shrink-0 text-teal transition-transform duration-200 group-data-[state=open]:rotate-180"
              aria-hidden
            />
          </AccordionTrigger>
          <AccordionContent className="text-sm sm:text-[15px]">
            <p className="px-4 sm:px-6 pb-4 sm:pb-5 text-slate-500 leading-relaxed">
              {row.description}
            </p>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default function IndustryTable({ industries, delay = 0.55 }) {
  const [sectionOpen, setSectionOpen] = useState(false);

  return (
    <FadeInSection y={16} duration={0.4} delay={delay} className="w-full min-w-0">
      <div className="mt-5 sm:mt-6 min-w-0">
        <button
          type="button"
          onClick={() => setSectionOpen((open) => !open)}
          aria-expanded={sectionOpen}
          className="use-case-industry-section-toggle w-full flex items-center justify-between gap-3 bg-off-white rounded-lg px-4 sm:px-6 py-3.5 sm:py-4 text-left transition-colors hover:bg-[#E8EEF4]/60"
        >
          <div className="min-w-0 flex-1">
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-teal">
              Where Businesses Use This
            </p>
            <p className="mt-0.5 text-xs sm:text-sm text-slate-500">
              {industries.length} industries — click to explore
            </p>
          </div>
          <ChevronDown
            className={`w-5 h-5 shrink-0 text-teal transition-transform duration-200 ${
              sectionOpen ? "rotate-180" : ""
            }`}
            aria-hidden
          />
        </button>

        {sectionOpen && (
          <div className="mt-2 bg-off-white rounded-lg overflow-hidden border border-[#E8EEF4]">
            <IndustryAccordion industries={industries} />
          </div>
        )}
      </div>
    </FadeInSection>
  );
}
